<template>
  <div class='poster-box vertical-type'>
    <div class='thumb-box'>
      <div class="picture-area" v-if='posterImage'>
        <WebpImage :imageInfo="{imageUrl: posterImage, width: 240, height: 360, onImageLoad}" />
      </div>
      <div v-else class='no-thumb' :aria-hidden='!isImageLoaded'>
        <span class='alt-text'>{{ posterAltText }}</span>
      </div>
    </div>
    <div class="picture-area">
      <WebpImage :imageInfo="{imageUrl: posterImage, width: 155, height: 87, option: 'b20', onImageLoad}" />
    </div>
  </div>
</template>

<script>
import WebpImage from '@/components/image/WebpImage'

export default {
  name: 'PosterVertical',
  components: { WebpImage },
  props: {
    posterImage: {
      type: String,
      default: null
    },
    posterAltText: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isImageLoaded: false
    }
  },
  methods: {
    onImageLoad () {
      this.isImageLoaded = true
    }
  },
  watch: {
    posterImage () {
      this.isImageLoaded = false
    }
  }
}
</script>
